import { useRef } from "react";

/** Keeps a ref synced with the latest value — useful for async callbacks and Formik submit handlers. */
export function useLatest<T>(value: T) {
    const ref = useRef(value);
    ref.current = value;
    return ref;
}
